module.exports = __webpack_public_path__ + "static/media/047.074dc114.jpg";